import {
  searchIifscDetailsActions,

} from "./action.js";

const initialState = {
  searchifscDetails: [],
  IfscLoading: false,
  searchIfscError: "",

};

const IifscDropdownReducer = (state = initialState, action) => {
  switch (action.type) {
    case searchIifscDetailsActions.SEARCH_IIFSC_SUCCESS:
      return {
        ...state,
        searchifscDetails: action.payload,
        IfscLoading: false,
      };
    case searchIifscDetailsActions.SEARCH_IIFSC_ERROR:
      return {
        ...state,
        searchIfscError: action.payload,
        IfscLoading: false,
      };
    case searchIifscDetailsActions.SEARCH_IIFSC_LOADING:
      return {
        ...state,
        IfscLoading: true,
      };

    default:
      return state;
  }
};

export default IifscDropdownReducer;
